import { render } from "./Card.vue?vue&type=template&id=07027f74&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=07027f74&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07027f74"

export default script